<template>
  <b-row class="blog-list-wrapper">
    <b-col
      v-for="post in blog"
      :key="post.url"
      md="4"
    >
      <b-card
        tag="article"
        no-body
      >
        <b-link
          :href="post.url"
          target="_blank"
        >
          <b-img
            :src="post.img"
            :alt="post.title"
          />
        </b-link>
        <b-card-body>
          <b-card-title>
            <b-link
              :href="post.url"
              target="_blank"
              class="h2 font-weight-bolder"
            >
              {{ post.title }}
            </b-link>
          </b-card-title>
          <!-- eslint-disable vue/no-v-text-v-html-on-component -->
          <b-card-text
            style="min-height: 40px;"
            v-html="post.description"
          />
          <hr />
          <div class="d-flex justify-content-end align-items-center">
            <b-link
              :href="post.url"
              target="_blank"
              class="font-weight-bold"
            >
              {{ $t('Read More') }}
            </b-link>
          </div>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BImg,
  BCardBody,
  BLink,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardBody,
    BCardTitle,
    BLink,
    BImg,
  },
  computed: {
    blog() {
      return [
        {
          title: 'EP Europace',
          img: 'https://www.hcs.gr/wp-content/uploads/2022/03/01_m_europace_cover.jpg',
          url: 'https://hcs.idm.oclc.org/login?url=https://academic.oup.com/europace',
        },
        {
          title: 'OCLC',
          img: 'https://www.hcs.gr/wp-content/uploads/2022/03/circ.2022.145.issue-11.largecover.jpg',
          url: 'https://hcs.idm.oclc.org/login?url=https://ovidsp.ovid.com/ovidweb.cgi?T=JS&NEWS=n&CSC=Y&PAGE=toc&D=ovft&AN=00003017-000000000-00000',
        },
        {
          title: 'JACC',
          img: 'https://www.hcs.gr/wp-content/uploads/2022/03/03_JACC-journal.jpg',
          url: 'https://hcs.idm.oclc.org/login?url=https://www.sciencedirect.com/journal/jacc-basic-to-translational-science',
          description: 'Basic to Translational Science',
        },
        {
          title: 'JACC',
          img: 'https://www.hcs.gr/wp-content/uploads/2022/03/04_X19368798.jpg',
          url: 'https://hcs.idm.oclc.org/login?url=https://www.sciencedirect.com/journal/jacc-cardiovascular-interventions',
          description: 'Cardiovascular Interventions',
        },
        {
          title: 'JACC',
          img: 'https://www.hcs.gr/wp-content/uploads/2022/03/05_X07351097.jpg',
          url: 'https://hcs.idm.oclc.org/login?url=https://www.sciencedirect.com/journal/jacc',
          description: 'Journal of the American College of Cardiology',
        },
        {
          title: 'JACC',
          img: 'https://www.hcs.gr/wp-content/uploads/2022/03/06_X08947317.jpg',
          url: 'https://hcs.idm.oclc.org/login?url=https://www.sciencedirect.com/journal/journal-of-the-american-society-of-echocardiography',
          description: 'Journal of the American Society of Echocardiography',
        },
      ]
    },
  },
}
</script>
